import React, { Component } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { withRouter} from 'react-router-dom';

import mixin from '../../../utils/mixin';
import consts from "../../../utils/constants";

const {methods} = mixin;

class NavbarMenu extends Component {

  constructor(props){
    
    super(props);

  }

  render() {
    return (
      <Navbar id="main_nav" bg="dark" expand="lg" className="navbar-dark">
        
        {this.props.development && this.props.development.url_image &&
          <Navbar.Brand href="/admin">
            <img src={this.props.development.url_image} alt="Lotes" height="60" />
          </Navbar.Brand>
        }
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav>
            <Nav.Link href="/admin">Lotes</Nav.Link>

            {
              methods.G_canDo(consts.Security.Action.VIEW_USERS, localStorage.getItem('user')) && 
              <Nav.Link href="/admin/users">Usuarios</Nav.Link>
            }

            {
              methods.G_canDo(consts.Security.Action.VIEW_AGENTS, localStorage.getItem('user')) && 
              <Nav.Link href="/admin/agents">Vendedores</Nav.Link>
            }

            {
              methods.G_canDo(consts.Security.Action.VIEW_REPORT, localStorage.getItem('user')) &&
              <NavDropdown title="Reportes" id="basic-nav-dropdown">
                { methods.G_canDo(consts.Security.Action.VIEW_INVENTORY_REPORT, localStorage.getItem('user')) &&
                  <NavDropdown.Item href="/admin/report/inventory">Inventario</NavDropdown.Item>
                }
                { methods.G_canDo(consts.Security.Action.VIEW_SALES_REPORT, localStorage.getItem('user')) &&
                  <NavDropdown.Item href="/admin/report/sales">Ventas</NavDropdown.Item>
                }
                { methods.G_canDo(consts.Security.Action.VIEW_VISITS_REPORT, localStorage.getItem('user')) && 
                  <NavDropdown.Item href="/admin/report/activity">Actividad</NavDropdown.Item>
                }
                { methods.G_canDo(consts.Security.Action.VIEW_HEAT_REPORT, localStorage.getItem('user')) && 
                  <NavDropdown.Item href="/admin/report/heatmap">Mapa de Actividad</NavDropdown.Item>
                }
              </NavDropdown>
            }
            
            <NavDropdown title={methods.G_renderName()} id="basic-nav-dropdown">
              <NavDropdown.Item href="/admin/profile">Mi Perfil</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={this.props.logout}>Cerrar Sesión</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>

        {this.props.development && (this.props.development.email || this.props.development.phone) &&
          <Nav className="d-none d-lg-block d-xl-block d-xll-block">
            {this.props.development.phone &&
              <Navbar.Text className="nav-text">{this.props.development.phone}</Navbar.Text>
            }
            {this.props.development.email &&
            <Navbar.Text className="nav-text"><a href="{this.props.development.phone}">{this.props.development.email}</a></Navbar.Text>
            }
          </Nav>
        }
      </Navbar>
    );
  }

}

export default withRouter(NavbarMenu);